import React from "react";
import { gql } from "apollo-boost";

import SettingsList from "superAdminViews/setting/SettingsList";

const ADD = gql`
  mutation createDriverHowItWorksByAdmin($title: String!, $description: String!) {
    createDriverHowItWorksByAdmin(input: { title: $title, description: $description }) {
      _id
      title
    }
  }
`;

const GET = gql`
  query getDriverHowItWorks($limit: Int, $skip: Int) {
    getDriverHowItWorks(pagination: { limit: $limit, skip: $skip }) {
      _id
      title
      description
    }
  }
`;

const COUNT = gql`
  query getDriverHowItWorksCount {
    getDriverHowItWorksCount
  }
`;

const UPDATE = gql`
  mutation updateDriverHowItWorksByAdmin($id: ID!, $title: String!, $description: String!) {
    updateDriverHowItWorksByAdmin(id: $id, input: { title: $title, description: $description }) {
      _id
      title
    }
  }
`;

const DELETE = gql`
  mutation removeDriverHowItWorksByAdmin($idSet: [ID!]!) {
    removeDriverHowItWorksByAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const FIELDS = [
  { name: "title", label: "Title", type: "text", required: true },
  {
    name: "description",
    label: "Explanation",
    type: "textarea",
    required: true,
    hint: "Shown in full in the driver app, so write it as a paragraph.",
  },
];

/**
 * DriverHowItWorks - the onboarding cards in the driver app.
 */
const DriverHowItWorks = () => (
  <SettingsList
    title="Driver how it works"
    description="The explanation new drivers read before their first trip."
    singular="section"
    list={{ query: GET, key: "getDriverHowItWorks" }}
    count={{ query: COUNT, key: "getDriverHowItWorksCount" }}
    create={{
      mutation: ADD,
      variables: (values) => ({
        title: values.title.trim(),
        description: values.description.trim(),
      }),
    }}
    update={{
      mutation: UPDATE,
      variables: (values, row) => ({
        id: row._id,
        title: values.title.trim(),
        description: values.description.trim(),
      }),
    }}
    remove={{ mutation: DELETE }}
    columns={[
      { key: "title", label: "Title", width: "1.5fr" },
      {
        key: "description",
        label: "Explanation",
        width: "3fr",
        render: (row) => <span className="settingsClamp">{row.description}</span>,
      },
    ]}
    fields={FIELDS}
    toValues={(row) => ({ title: row.title, description: row.description })}
  />
);

export default DriverHowItWorks;
